// removed by extract-text-webpack-plugin
module.exports = {"Card":"_1HLMkjVLjYZtbPtzPFyGIE","Footer":"_2M-kwVTwjcDqOedJCyOORQ","IconLeft":"_2_UEEU7LiSTCRZOfPiE4GR","Btn":"_2y73OWmzuMyRCKZw7PdRQV","TabTable":"_1ScqP4XQgtS0baEeElslhI","TabBar":"aPOsyeWsNBSdYc0_JRCGA","container-fluid":"_22yC00_UWQtIg_dSfpCG45"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfUser/PrepaidDetails/styles.module.css
// module id = 641
// module chunks = 0